import PropTypes from 'prop-types';
import ContentPopoverEmptyState from '../../../draft-content-transplant/ContentPopoverEmptyState';
import { getMeetingsUrl } from '../../../draft-transplant/utils/links';
import { jsx as _jsx } from "react/jsx-runtime";
const MeetingPopoverEmptyState = () => /*#__PURE__*/_jsx(ContentPopoverEmptyState, {
  image: "meetings",
  title: "draftPlugins.meetings.popover.zeroState.header",
  description: "draftPlugins.meetings.popover.zeroState.description",
  buttonLabel: "draftPlugins.meetings.popover.zeroState.button",
  buttonLink: getMeetingsUrl()
});
MeetingPopoverEmptyState.propTypes = {
  portalId: PropTypes.number.isRequired
};
export default MeetingPopoverEmptyState;